import React from "react";
import styles from "./Section.module.css";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
const Section = (props) => {
  let sectionStyle = styles.Section;
  if (props.open === props.subject.main) {
    sectionStyle = styles.OpenSection;
  }
  return (
    <li
      onMouseEnter={() => {
        if (window.innerWidth > 500) {
          return props.setOpen(props.subject.main);
        }
      }}
      onMouseLeave={() => {
        if (window.innerWidth > 500) {
          return props.setOpen(null);
        }
      }}
      onClick={() => {
        if (window.innerWidth <= 500) {
          return props.setOpen(
            props.open === props.subject.main ? null : props.subject.main
          );
        }
      }}
      className={sectionStyle}
      data-nav-item-id={props.subject.main}
      data-nav-list-trigger={props.subject.main}
    >
      <a>
        {props.subject.main}
        <ArrowDropDownIcon className={styles.Icon} />
      </a>
      {props.open == props.subject.main ? (
        <div className={styles.ExpandedMenu}>
          {props.subject.subsections.map((subsection) => {
            return (
              <a
                key={subsection.name.split(" ").join("")}
                href={subsection.link}
              >
                {subsection.name}
              </a>
            );
          })}
        </div>
      ) : null}
    </li>
  );
};

export default Section;
